import {
  CategoryOutlined,
  Inventory2Outlined,
  LocalShippingOutlined,
  PaidOutlined,
  ScheduleOutlined,
  SpeedOutlined,
  SvgIconComponent,
  TuneOutlined,
  ViewListOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';

/**
 * セクションの並び順の正本。
 *
 * 「休憩時間設定 (幹線輸送)」「荷姿ごとの変換ルール」は #328 で画面から外したのでここに無い。
 * API・DB は温存しているので、撤去する別 issue までは保存済みの値が残る。
 * 「項目表示設定」(#330) は後続 issue で足す。
 */
export const SECTION_ORDER = [
  'global',
  'speed',
  'timeband',
  'largeVehicle',
  'cost',
  'handling',
  'display',
  'fields',
  'vehicleAttr',
] as const;

export type SectionId = (typeof SECTION_ORDER)[number];

/** サイドナビのラベルは短くする。セクション見出しはこれより長い場合がある */
export const SECTION_DEFS: Record<SectionId, { label: string; icon: SvgIconComponent }> = {
  global: { label: 'グローバル設定', icon: TuneOutlined },
  speed: { label: '移動速度の調整', icon: SpeedOutlined },
  timeband: { label: '時間帯の設定', icon: ScheduleOutlined },
  largeVehicle: { label: '大型車両の割付条件', icon: LocalShippingOutlined },
  cost: { label: 'コスト設定', icon: PaidOutlined },
  handling: { label: '荷捌き時間設定', icon: Inventory2Outlined },
  display: { label: '表示設定', icon: VisibilityOutlined },
  fields: { label: '項目設定', icon: ViewListOutlined },
  vehicleAttr: { label: '車両表示設定', icon: CategoryOutlined },
};

export type SettingsSection = {
  /** アンカーの id。ジャンプボタンからこの id 宛にスクロールする */
  id: SectionId;
  label: string;
  icon: SvgIconComponent;
};

export const SECTIONS: SettingsSection[] = SECTION_ORDER.map((id) => ({ id, ...SECTION_DEFS[id] }));

/** 検索ボックスの入力でサイドナビのセクションを絞り込む。一致 0 件なら空配列 */
export const searchSections = (query: string): SettingsSection[] => {
  const normalized = query.trim().toLocaleLowerCase('ja');
  if (!normalized) return SECTIONS;

  return SECTIONS.filter((section) => section.label.toLocaleLowerCase('ja').includes(normalized));
};
